import React from 'react'
import resolveProps from '../../utils/resolveProps'

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  Controller,
  Virtual,
  Autoplay
} from 'swiper'
// Direct React component imports
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react'

import './index.scss'

import { useSwipper } from './useSwipper'

const config = {
  types: ['inverse', 'bullets', 'beta'],
  modifiers: [],
  state: []
}

SwiperCore.use([Navigation, Pagination, Scrollbar, Controller, Virtual, Autoplay])

export default function Swiper(props) {
  const {
    slidesPerView = 'auto',
    beta = false,
    bullets,
    children,
    currentSlide,
    navigationButtons = {},
    pagination = {},
    onBeforeInit,
    ...rest
  } = props

  const swiperRef = React.useRef(null)
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
  const paginationElementRef = React.useRef(null)

  const { prevProps = {}, nextProps = {}, parentProps = {} } = navigationButtons
  const { bulletProps = {} } = pagination
  const paginationParentProps = pagination.parentProps || {}

  const [controlledSwiper, setControlledSwiper] = React.useState(null)

  const [swiperRoot, setSwiperRoot] = React.useState(null)

  const mdnClasses = `${resolveProps(props, config, 'Swiper')}`

  const arrayChildren = React.Children.toArray(children)
  const { setSwipperAttrs } = useSwipper({
    navigationPrevRef,
    navigationNextRef,
    paginationElementRef
  })

  const swipperParams = setSwipperAttrs(props, swiperRef)
  const { customParams } = swipperParams

  const templateClasses = `${mdnClasses} ${slidesPerView === 'auto' ? 'mdn-Swiper--auto' : ''
    }`.trim()

  const parentNavigationClassName = (
    'mdn-SwiperSlide-buttons' + ` ${parentProps.className || ''}`
  ).trim()

  const parentPaginationClassName = (
    ['mdn-SwiperSlide-pagination', 'mdn-Swiper-pagination'].join(' ') +
    ` ${paginationParentProps.className || ''}`
  ).trim()





  const buttonPrevClassName = (
    [
      'mdn-SwiperSlide-buttonPrev',
      'mdn-Swiper-button-prev',
      'mdn-Icon-esquerda',
      'mdn-Icon--lg',
      'mdn-SwiperSlide-buttonNavigation'
    ].join(' ') + ` ${prevProps?.className || ''}`
  ).trim()
  const buttonNextClassName = (
    [
      'mdn-SwiperSlide-buttonNext',
      'mdn-Swiper-button-next',
      'mdn-Icon-direita',
      'mdn-Icon--lg',
      'mdn-SwiperSlide-buttonNavigation'
    ].join(' ') + ` ${nextProps?.className || ''}`
  ).trim()



  React.useEffect(() => {
    swiperRoot?.slideTo(currentSlide)
  }, [currentSlide, swiperRoot])

  return (
    <div className={`${templateClasses} `}>
      <SwiperComponent
        className="mdn-Swiper-container"
        ref={swiperRef}
        watchSlidesProgress={true}
        watchOverflow={true}
        navigation={swipperParams.navigation} //{swipperParams.navigation} {true}
        breakpoints={swipperParams.breakpoints}
        pagination={swipperParams.pagination}
        slidesPerView={swipperParams.slidesPerView}
        observer={true}
        spaceBetween={swipperParams.spaceBetween}
        onBeforeInit={(swiper) => {
          setSwiperRoot(swiper) // save swiper original methods to be invoked anywhere
           // @ts-ignore
          swiper.params.navigation.prevEl = navigationPrevRef.current
           // @ts-ignore
          swiper.params.navigation.nextEl = navigationNextRef.current
           // @ts-ignore
          swiper.params.pagination.el = paginationElementRef.current
          onBeforeInit && onBeforeInit(swiper)
        }}
        controller={{ control: controlledSwiper }}
        onSwiper={setControlledSwiper}
        {...customParams}
        {...rest}
      >
        <div className={'mdn-Swiper-wrapper'}>
          {React.Children.map(arrayChildren, (child, index) => {
            return (
              <SwiperSlide
                virtualIndex={index}
                key={`slide_${index}`}
                className={'mdn-Swiper-slide'}
              >
                {child}
              </SwiperSlide>
            )
          })}
        </div>

        {!!bullets && React.Children.toArray(children).length > 1 ? (
          <div
            ref={paginationElementRef}
            slot={'container-end'}
            {...paginationParentProps}
            className={parentPaginationClassName}
          />
        ) : (
          <div
            slot={'container-end'}
            {...parentProps}
            className={parentNavigationClassName}
          >
            <button
              ref={navigationPrevRef}
              {...prevProps}
              className={buttonPrevClassName}
            ></button>
            <button
              ref={navigationNextRef}
              {...nextProps}
              className={buttonNextClassName}
            ></button>
          </div>
        )}
      </SwiperComponent>
    </div>
  )
}
